import React from 'react';
import { observer, inject } from 'mobx-react';
import dompurify from 'dompurify';

import Avatar from '../Avatar/Avatar';
import { shorten } from '../../util/stringUtils';
import CauzeButton from '../CauzeButton/CauzeButton';
import FollowButton from '../FollowButton/FollowButton';
import { normalizeContext } from '../../util/contextUtils';
import { navigate } from '@reach/router';
import useSearchStore from 'stores/SearchStoreV2';
import CauzeMatchBadge from 'components/CauzeMatchBadge/CauzeMatchBadge';
import LargeNumber from 'components/LargeNumber/LargeNumber';
import { ReactComponent as EllipsisIcon } from 'assets/images/icons/dots/three-dots-hollow.svg';
import { CHECKOUT_TYPE, FRAME } from 'stores/CheckoutStoreV2';

const SearchItem = ({
  charity,
  onLearnMore,
  onFollowCharity,
  userContext,
  uiStore,
  isAuthenticated,
  profileStore,
}) => {
  const searchStore = useSearchStore();
  const followerCount = charity?.followerCount;
  const sanitizer = dompurify.sanitize;

  const showFollowersModal = () => {
    // searchStore.getFollowersForResult({
    //   userContext: normalizeContext(userContext),
    //   targetContext: { charityId: charity.id },
    // });
    // uiStore.openModal('ENTITY_LIST', {
    //   title: `${followerCount} Follower${followerCount === 1 ? '' : 's'}`,
    //   showFollow: true,
    //   buttonLabel: 'Follow',
    //   isSelf: false,
    //   store: searchStore,
    //   userContext,
    //   loadingKey: 'loadingFollowers',
    //   entitiesKey: 'charityFollowers',
    //   isAuthenticated: isAuthenticated,
    // });
  };

  const onDonate = () => {
    uiStore.openModal('CHECKOUT', {
      giftToken: uiStore.savedUiState?.userToken?.token,
      hideAmount: uiStore.savedUiState?.userToken?.gift?.hideAmount,
      giftAmount: uiStore.savedUiState?.userToken?.gift?.amount,
      email: uiStore.savedUiState.userToken?.email || profileStore?.data?.email,
      initiatorId: uiStore.savedUiState.userToken?.gift?.initiatorCompany?.id,
      checkoutType: uiStore.savedUiState?.userToken?.token
        ? CHECKOUT_TYPE.GIFTED_DONATION
        : CHECKOUT_TYPE.DONATION,
      charityIds: [charity.id],
      eventId: null,
      amount: uiStore.savedUiState?.userToken?.gift?.amount || 500,
      onCheckoutSuccess: async () => {
        profileStore.getProfile();
      },
      frame: uiStore.savedUiState?.userToken?.token
        ? FRAME.GIFT_CHECKOUT
        : FRAME.CHECKOUT,
    });
  };

  return (
    <div className="p-6 flex flex-col rounded-lg border border-solid border-gray-200 bg-white search-item">
      <div className="flex gap-x-4">
        <Avatar noBorder md avatar={charity.avatar} onClick={onLearnMore} />
        <div className="flex-1">
          <div onClick={onLearnMore} className="flex flex-col cursor-pointer">
            <p className="font-agenda-bold text-lg text-gray-1b2 leading-tight">
              {charity.name}
            </p>
            <p className="text-sm text-gray-600 font-agenda">
              NONPROFIT | {charity.city}, {charity.state}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-y-1">
          <div className="flex justify-end">
            <CauzeMatchBadge charity={charity} />
          </div>
        </div>
      </div>
      {charity.description && (
        <div
          className="text-gray-700 text-sm leading-relaxed font-agenda py-2 cursor-pointer"
          onClick={onLearnMore}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizer(shorten(charity.description, 250), {
                ADD_ATTR: ['target'],
              }),
            }}
          />
        </div>
      )}
      <div className="flex gap-x-1 ml-auto">
        {Boolean(followerCount) && Boolean(followerCount) && (
          <div>
            <span className="text-sm font-agenda-medium text-gray-900">
              <LargeNumber amount={followerCount} />
            </span>{' '}
            <span className="text-sm font-agenda uppercase text-gray-600">
              Follower
              {followerCount !== 1 && 's'}
            </span>
          </div>
        )}
        {Boolean(followerCount) && Boolean(followerCount) && (
          <div className="event-item-avatar-group" onClick={showFollowersModal}>
            {charity?.featuredFollowers?.slice(0, 5).map((follower) => (
              <Avatar noBorder xsm avatar={follower.avatarUrls} />
            ))}
            {followerCount >= 5 && (
              <EllipsisIcon className="event-item-ellipsis" />
            )}
          </div>
        )}
      </div>
      <div className="flex gap-x-2 font-agenda mt-2">
        <FollowButton
          className="flex-1 pt-2 pb-1"
          onFollow={() => {
            if (!isAuthenticated) {
              uiStore.openModal('CONFIRM', {
                message: `Please Login or Signup to follow ${
                  charity.name || 'this Nonprofit'
                }.`,
                action: () => {
                  navigate('/login');
                },
                confirmText: 'Login/Signup',
                cancelText: 'Not Now',
                bodyMessage:
                  'Create your own Cauze account and join our community of givers.',
              });
              return;
            }

            onFollowCharity({
              follow: !charity.isSelfFollowing,
              actorContext: normalizeContext(userContext),
              charityId: charity.id,
            });
          }}
          following={charity.isSelfFollowing}
        />
        <button className="cz-btn-brand pt-2 pb-1 flex-1" onClick={onDonate}>
          Give
        </button>
      </div>
    </div>
  );
};

export default inject('uiStore', 'profileStore')(observer(SearchItem));
